"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const IgnoredField_1 = __importDefault(require("components/IgnoredField"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const IgnoreField = ({ attributes, callbacks, editable, fieldActive, txn, showIcons, focusField, }) => {
    const { classes } = useStyles();
    return (<styles_1.RegListItem {...attributes} tabIndex={null} onClick={null} className={classes.iconButtonColumn}>
      <IgnoredField_1.default value={txn} autoFocus={fieldActive} inputRef={fieldActive ? (input) => {
            focusField.current = input; // eslint-disable-line
        } : null} onChange={(e) => { var _a; return (_a = callbacks.handleMenu) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'ignored', txn, e.target.value); }} classes={{ iconRoot: classes.iconButtonColumn }} show={(txn.isExcludedFromReports || txn.isExcludedFromF2S) || editable || showIcons}/>
    </styles_1.RegListItem>);
};
exports.default = IgnoreField;
